import { ISortable } from "../../helpers/sort";
import { SortItem } from "../ss-api/responses/member.dashboard.license.response";

export interface IAdminItem  {
    AdminID: number;
    FirstName: string;
    LastName: string;
    Username: string;
    Email: string;
    TrainingDialinPhone: string;
    HTMLEmailSignature: string;
    Hidden: boolean;
}

export class AdminItemArray extends Array<AdminItem> implements ISortable {
    
    public LastSort = new SortItem;

    constructor(...items: AdminItem[]) {
        super(...items);
        Object.setPrototypeOf(this, AdminItemArray.prototype);
    }

}

export class AdminItem  implements IAdminItem {
    AdminID: number;
    FirstName: string;
    LastName: string;
    Username: string;
    Email: string;
    TrainingDialinPhone: string;
    HTMLEmailSignature: string;
    Hidden: boolean;
}
